import { Color } from '@billy/design-system'
import styled from '@emotion/styled'

interface ItemButtonProps {
  isSelected: boolean
}

export const ItemButton = styled.button<ItemButtonProps>`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: var(--lumen-height-48);
  padding: var(--lumen-padding-8);
  border: none;
  border-radius: 0;
  background-color: ${({ isSelected }) => (isSelected ? Color.Grey150 : 'transparent')};
  font-family: inherit;
  font-size: inherit;
  text-align: left;
  cursor: pointer;

  &:focus,
  &:focus-visible {
    outline: none;
    box-shadow: none;
  }

  &:hover {
    background-color: ${Color.Grey100};
  }
`

export const AccountNumber = styled.span`
  display: inline-block;
  /* Aligns separators across rows when account numbers vary in digit count. */
  min-width: 9ch;
  font-variant-numeric: tabular-nums;
  text-align: right;
`

export const Separator = styled.span`
  margin: 0 var(--lumen-spacing-4);
  color: ${Color.Grey300};
`

export const Label = styled.span`
  flex: 1;
  min-width: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`
